import type { ReactNode } from "react";
import { cn } from "@/modern/utils";
import { ENTITY_FINDER_META_CLS } from "@/modern/components/entity-finder/constants/layout";
export type EntityFinderMetaBadgeVariant =
  | "muted"
  | "status"
  | "success"
  | "personal"
  | "board";

const VARIANT_STYLES: Record<EntityFinderMetaBadgeVariant, string> = {
  muted: "border-border/50 bg-muted/30 text-muted-foreground",
  status: "border-border/40 bg-background/60 text-foreground/65",
  success: "border-emerald-500/25 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
  personal: "border-border/50 bg-accent/25 text-muted-foreground",
  board: "border-primary/25 bg-primary/10 text-primary",
};

interface EntityFinderMetaBadgeProps {
  children: ReactNode;
  variant?: EntityFinderMetaBadgeVariant;
  className?: string;
  title?: string;
}

export function EntityFinderMetaBadge({
  children,
  variant = "muted",
  className,
  title,
}: EntityFinderMetaBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex max-w-[9rem] shrink-0 items-center truncate rounded-md border px-2 py-0.5",
        ENTITY_FINDER_META_CLS,
        VARIANT_STYLES[variant],
        className
      )}
      title={title}
    >
      {children}
    </span>
  );
}
